module.exports = __webpack_public_path__ + "static/media/login-background.70fa8b35.svg";